import { isPlatformBrowser } from "@angular/common";
import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { Platform } from "@ionic/angular";
import { GlobalDataService } from "src/app/services/global-data.service";
import { JsonLdService } from "src/app/services/json-ld.service";
import { SeoService } from "src/app/services/seo.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-mall-map",
  templateUrl: "./mall-map.page.html",
  styleUrls: ["./mall-map.page.scss"],
})
export class MallMapPage implements OnInit {
  cordova: boolean = false;
  showMap: boolean = false;
  isBrowser: boolean = false;
  title: string = environment.environment_name == "rosebank" 
    ? "Rosebank Mall Map | Find Your Way Around" 
    : environment.environment_name == "clearwater" 
    ? "Clearwater Mall | Mall Map & Store Directory"
    : environment.environment_title + " Mall Map";
  excerpt: string = `Experience one of Africa's leading super-regional retail centres. View the map of all the stores inside ${environment.environment_title} to ensure you know exactly where you are going.`;

  constructor(
    private platform: Platform,
    private globalData: GlobalDataService,
    private seo: SeoService,
    private jsonLdService: JsonLdService,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    this.platform.ready().then(() => {
      this.cordova = this.platform.is("cordova");
    });
  }

  ngOnInit() {
    const initialMallData = this.globalData.getGlobalData();

    // Set Meta & Social tags
    if (!this.cordova) {
      let schemaData = {};

      // Title tag
      this.seo.setTitle(this.title);
      schemaData = {
        ...schemaData,
        name: this.title,
      };

      // Description tag
      const seoData = {
        title: this.title,
        description: this.excerpt,
        keywords: initialMallData.general.metaKeywords + " offers",
        socialImage: initialMallData.social.openGraphImage,
      };
      this.seo.setMeta(seoData);
      this.seo.setSEOMeta(seoData);
      schemaData = {
        ...schemaData,
        description: this.excerpt,
      };

      this.jsonLdService.insertSchema(schemaData);
    }
  }

  ionViewDidEnter() {
    this.showMap = true;
  }

  ionViewWillLeave() {
    this.showMap = false;

    if (this.isBrowser && document.getElementById("mappedin-wrapper"))
      document.getElementById("mappedin-wrapper").remove();
  }
}
